// crypto-util.ts
export class CryptoUtil {
  static async encryptConfig(json: object, secretKey: string): Promise<string> {
    const encoder = new TextEncoder();
    const iv = crypto.getRandomValues(new Uint8Array(16));

    const key = await crypto.subtle.importKey(
      "raw",
      encoder.encode(secretKey.padEnd(32).slice(0, 32)), // ensure 32 bytes
      { name: "AES-CBC" },
      false,
      ["encrypt"]
    );

    const encoded = encoder.encode(JSON.stringify(json));
    const encrypted = await crypto.subtle.encrypt({ name: "AES-CBC", iv }, key, encoded);

    return JSON.stringify({
      iv: btoa(String.fromCharCode(...iv)),
      data: btoa(String.fromCharCode(...new Uint8Array(encrypted)))
    });
  }

  static async decryptConfig(encString: string, secretKey: string): Promise<any> {
    const payload = JSON.parse(encString); // ✅ now this is a string, not object

    const iv = Uint8Array.from(atob(payload.iv), c => c.charCodeAt(0));
    const data = Uint8Array.from(atob(payload.data), c => c.charCodeAt(0));

    const encoder = new TextEncoder();
    const key = await crypto.subtle.importKey(
      "raw",
      encoder.encode(secretKey.padEnd(32).slice(0, 32)),
      { name: "AES-CBC" },
      false,
      ["decrypt"]
    );

    const decrypted = await crypto.subtle.decrypt({ name: "AES-CBC", iv }, key, data);
    const decoded = new TextDecoder().decode(decrypted);
// console.log(decoded)
    return JSON.parse(decoded);
  }
}
